  <div class="truck-overview-filter no-field-space">
    <sc-flex >
      <mat-form-field class="grow" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="shared.tmc-table.filter"></sc-dictionary-label>
        </mat-label>
        <input matInput [formControl]="textFilterFormControl" [maxLength]="255">
      </mat-form-field>
    </sc-flex>
  </div>
